import { render, staticRenderFns } from "./class_details.vue?vue&type=template&id=6c42d385&"
import script from "./class_details.vue?vue&type=script&lang=js&"
export * from "./class_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports